import React, {FC} from 'react';
import { useNavigate } from "react-router-dom";
import {storiesListClasses, StyledStoriesList} from "./StyledStoriesList";
import {Card, CardContent, CardMedia, Button, Grid, Typography, Box} from "@mui/material";
import {IStory} from "../interfaces/IStory";

import location from "../../assets/location.png";
import { NavigationRoutes } from "../../routes";
import { trackPdfInteraction } from "../../common/hooks";

import LspMagazine from "./LSP_Magazine.png";

interface IStoriesList  {
    stories: IStory[]
}

export const StoriesList: FC<IStoriesList> = ({stories}) => {
    const navigate = useNavigate();

    const openPDF = (pdfFileUrl: string) => {
        trackPdfInteraction(pdfFileUrl, "stories_list");
        window.open(pdfFileUrl, '_blank');
    };

    const clickTag = (keyword: string) => (event: React.MouseEvent) => {
        event.stopPropagation();
        const formattedKeyword = keyword.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        navigate(`/${NavigationRoutes.Stories}/all/${formattedKeyword}`);
            
        window.scrollTo({
            top: document.getElementById('storiesList')?.offsetTop,
            behavior: 'smooth'
        });
    };

    // New function for handling story navigation
    const navigateToStory = (storyId: string) => {
        navigate(`/${NavigationRoutes.Story}/${storyId}`);
        window.scrollTo(0, 0);
    };
    
    return <StyledStoriesList 
        container 
        spacing={0} 
        columnSpacing={4} 
        sx={{
            display: 'grid',
            rowGap: 5,
            gridTemplateColumns: {
                xs: '1fr',           // mobile: 1 column
                md: 'repeat(6, 1fr)' // desktop: 3 columns
            },
        }}
        className={storiesListClasses.root} id="storiesList">

        <Grid item sx={{ 
                gridColumn: { xs: 'span 1', md: 'span 3', lg: 'span 4' },
                order: { xs: 2, md: 1 }, // Second on mobile, first on desktop
            }}>
            <Typography variant={"h2"} component="div" className={storiesListClasses.header}>
                Read stories
                <Box sx={{ display: { xs: 'none', lg: 'block' }, height: '1em' }} />
                <Box sx={{ display: { xs: 'none', lg: 'block' }, height: '1em' }} />
            </Typography>
        </Grid>

        <Grid item sx={{ 
                gridColumn: { xs: 'span 1', md: 'span 3', lg: 'span 2' },
                gridRow: { xs: 'span 1', md: 'span 2' },
                order: { xs: 1, md: 2 }, // First on mobile, second on desktop
            }}>
            <div style={{ background: "#011E3F", padding: "1px 24px 24px 24px", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}>
                <Typography variant={"h2"} component="div" sx={{
                    display: "block",
                    margin: "70px 0 20px 0",
                    zIndex: 100,
                    textAlign: "left",
                    fontSize: "36px",
                    lineHeight: "42px",
                    fontWeight: "400",
                    marginBottom: "20px",
                    color: "#FFFFFF"
                }}>
                    Download the LSP Magazine
                </Typography>

                <img src={LspMagazine} alt={"LSP Magazine"} style={{width:"100%", marginBottom:"20px"}} />
                
                <Button variant={"contained"} 
                    onClick={() => openPDF('/pdfs/LSP_MAGAZINE_VOLUME_I.pdf')} 
                    sx={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: "10px",
                    minWidth: "185px",
                    padding:"10px 25px", 
                    height:"auto!important", 
                    width:"100%", 
                    marginBottom:"10px",
                    background: "#FFFFFF",
                    color: "#011E3F",
                    "&:hover": {
                        background: "#F4F5F6"
                    }
                }}>
                    Volume 1, SRHR-UHC <br /> LSP Magazine, 2023
                </Button>
                <Button variant={"contained"} 
                    onClick={() => openPDF('/pdfs/WHO LSP Magazine 2025 D11.pdf')} 
                    sx={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: "10px",
                    minWidth: "185px",
                    padding:"10px 25px", 
                    height:"auto!important", 
                    width:"100%", 
                    marginBottom:"10px",
                    background: "#FFFFFF",
                    color: "#011E3F",
                    "&:hover": {
                        background: "#F4F5F6"
                    }
                }}>
                    Volume 2, SRHR-UHC <br /> LSP Magazine, 2025
                </Button>
            </div>
        </Grid>

        {stories.slice().reverse().map((story) => (        
            <Grid item sx={{ 
                order: 5, // First on mobile, second on desktop
                gridColumn: { xs: 'span 1', md: 'span 3', lg: 'span 2' },
            }}>
                <Card className={storiesListClasses.card}>
                    <CardMedia
                        component="img"
                        image={story.image}
                        alt={story.imagealt}
                        className={storiesListClasses.cardImg}
                        onClick={() => navigateToStory(story.id)}
                        style={{ cursor: 'pointer' }}
                    />
                    {story.keywords && (
                        <Grid container className={storiesListClasses.keywords} wrap={"wrap"}>
                            {story.keywords.map((keyword, index) => (
                                <Typography key={index} className={storiesListClasses.keywordtag} onClick={clickTag(keyword)}>
                                    {keyword}
                                </Typography>
                            ))}
                        </Grid>
                    )}
                    <Grid container className={storiesListClasses.cardLocation}>
                        <img src={location} alt={"location"}/>
                        <Typography variant={"h6"}>{story.country}</Typography>
                    </Grid>

                    <CardContent className={storiesListClasses.cardContent}>
                        <Typography gutterBottom variant="h6" className="storyHeader">
                            {story.header}
                        </Typography>
                    </CardContent>

                    <div>
                        <Button 
                            variant={"contained"} 
                            className={storiesListClasses.button}
                            onClick={() => navigateToStory(story.id)}
                        >
                            Read Full Story
                        </Button>
                    </div>
                </Card>
            </Grid>
        ))}


    </StyledStoriesList>;
};
